module.exports = __webpack_public_path__ + "img/training-plan.636eb3b0.svg";